import { render, staticRenderFns } from "./quest.vue?vue&type=template&id=30484cce"
import script from "./quest.vue?vue&type=script&lang=js"
export * from "./quest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports